import moment from 'moment';
import axios from '../../api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueNotification } from '../../store/notification/action';

export const getUserCampaignList = createAsyncThunk('userCampaignList', async () => {
  const response = await axios.get('/campaigns/user-campaign-list');
  return {data: response.data, lastRefresh: moment().format("DD/MM/YYYY HH:mm:ss")};
});

export const getCampaignListWithTargetFiltering = createAsyncThunk('userCampaignListWithTargetFiltering', async (filters: any) => {
  console.log('fetching api for campaign list with filters', filters)
  const response = await axios.post('/campaigns/user-campaign-list-filtered', filters);
  return  response.data;
});

export const getCustomerTargetFilters = createAsyncThunk('getCustomerFilters', async () => {
  const response = await axios.get('/campaigns/customer-filter-attributes');
  return response.data;
});

export const getTimelineUserFilters = createAsyncThunk('timelineUserFilters', async () => {
  const response = await axios.get('/campaigns/timeline-user-filters');
  return response.data;
});

export const updateTimelineUserFilters = createAsyncThunk('updateTimelineUserFilters', async (filters: any[]) => {
  const response = await axios.post('/campaigns/timeline-user-filters', filters);
  return response.data;
});

export const updateUserTimelineCampaigns = createAsyncThunk('updateCampaignsTimeline', async (payload: any, { rejectWithValue, dispatch }) => {
  try {
    await axios.post('/campaigns/update/timeline', payload);
    dispatch(getUserCampaignList());
  } catch (error) {
    // @ts-ignore
    return rejectWithValue(error.response.data);
  }
});

export const deleteCampaign = createAsyncThunk(
  'userCampaignList/deleteCampaign',
  async (campaignId: number, { rejectWithValue, dispatch }) => {
    try {
      await axios.delete(`/campaigns/${campaignId}`);
      dispatch(enqueueNotification('Campaign deleted successfully.', 'success', 5000));
      dispatch(getUserCampaignList());
      return { campaignId };
    } catch (error: any) {
      dispatch(enqueueNotification('Failed to delete the campaign.', 'error'));
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const restoreCampaign = createAsyncThunk(
  'userCampaignList/restoreCampaign',
  async (campaignId: number, { rejectWithValue, dispatch }) => {
    try {
      await axios.patch(`/campaigns/${campaignId}/restore`);
      dispatch(enqueueNotification('Campaign restored successfully.', 'success', 5000));
      dispatch(getUserCampaignList());
      return { campaignId };
    } catch (error: any) {
      dispatch(enqueueNotification('Failed to restore the campaign.', 'error'));
      return rejectWithValue(error?.response?.data);
    }
  },
);
